import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'
import type { IProgrammeReport } from '@/interfaces/api/Dara/Programme'

export default {
  baseUrl() {
    const appStore = useAppStore()

    return `${appStore.daraApiBaseUrl}/programmes/`
  },

  getReports(programmeId: number) {
    return axios.get<IProgrammeReport[]>(this.baseUrl() + programmeId + '/reports')
  },
}
